import ApiBase from '../ApiBase';

export default new class extends ApiBase {
    create = (data) => this.post('sage/sync', data);

    customers = (data) => this.post('sage/customers', data);
};
